export function stringFormat(word: string): string {
  return word.replace(/\sи /gi, ' и\u00a0');
}
